export interface TagDefinition {
    id: string,
    text: string,
    color: string,
}

export const DEFAULT_TAGS: TagDefinition[] = [
    { id: '1', text: '', color: '#2C5F2D' },
    { id: '2', text: '', color: '#737373' },
    { id: '3', text: '', color: '#4CAF50' },
    { id: '4', text: '', color: '#FFA500' },
    { id: '5', text: '', color: '#FF4500' },
    { id: '6', text: '', color: '#1E90FF' },
    { id: '7', text: '', color: '#A9A9A9' },
    { id: '8', text: '', color: '#333333' },
];
